import React from 'react';
import styled from 'styled-components';
import { Circle } from 'lucide-react';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  border-radius: 999px;
  font-size: ${props => props.$style.fontSize || '0.875rem'};
  font-weight: 500;
  background: ${({ status }) => {
    switch (status) {
      case 'Hold':
        return '#fef3c7';
      case 'In_Progress':
        return '#dbeafe';
      case 'Complete':
        return '#dcfce7';
      case 'Canceled':
        return '#fee2e2';
      default:
        return '#f3f4f6';
    }
  }};
  color: ${({ status }) => {
    switch (status) {
      case 'Hold':
        return '#92400e';
      case 'In_Progress':
        return '#1e40af';
      case 'Complete':
        return '#166534';
      case 'Canceled':
        return '#991b1b';
      default:
        return '#374151';
    }
  }};
  border: 1px solid ${({ status }) => {
    switch (status) {
      case 'Hold':
        return '#fbbf24';
      case 'In_Progress':
        return '#60a5fa';
      case 'Complete':
        return '#34d399';
      case 'Canceled':
        return '#ef4444';
      default:
        return '#e5e7eb';
    }
  }};
`;

const StatusBadge = ({ status, circleSize = 8, style={} }) => {
  return (
    <Badge 
      status={status} 
      $circleSize={circleSize}
      $style={style}
    >
      <Circle size={circleSize ? parseInt(circleSize) : 8} fill="currentColor" />
      {status.replace('_', ' ')}
    </Badge>
  );
};

export default StatusBadge;